import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source']

  fillFields (event) {
    const object = JSON.parse(event.target.value)

    Object.keys(object).forEach(key => {
      const input = this.element.querySelector(`input[name*="${key}"]`)

      if (input) {
        input.value = object[key]
      }
    })
  }
}
